import React from 'react';

import { useParams, useOutletContext, Link } from 'react-router-dom';

import { db } from './firebase'
import { useHuntPlayers, nameOf } from './members';
import SubmissionMedia from './play/SubmissionMedia';
import { collection, query, doc, orderBy, where} from "firebase/firestore";
import { useCollection, useDocument } from 'react-firebase-hooks/firestore';

import moment from 'moment';


export default function Gallery() {
    let { huntId } = useParams();
    const { uid } = useOutletContext();

    // State from firebase
    const huntRef = doc(db, "hunts", huntId);

    const itemsRef = collection(db, "hunts", huntId, "items");
    const itemsQuery = query(itemsRef, orderBy("author"));

    const submsRef = collection(db, "hunts", huntId, "submissions");
    const submsQuery = query(submsRef, where("active", "==", true));

    const [hunt, huntLoading, huntError] = useDocument(huntRef);
    const memberIds = hunt?.data()?.memberIds;
    const [players, playersLoading, playersError] = useHuntPlayers(memberIds);
    const [items, itemsLoading, itemsError] = useCollection(itemsQuery);
    const [subms, submsLoading, submsError] = useCollection(submsQuery);

    // Probably a better way to do this lol
    if (huntLoading || playersLoading || itemsLoading || submsLoading) {
        return <p>Loading</p>
    }

    if (huntError || playersError || itemsError || submsError) {
        return <p>Error!</p>
    }

    // Gate access to members. Unmigrated hunts have no memberIds and will
    // fail subcollection reads under the deployed rules, so treat them the
    // same as not-a-member.
    if (!Array.isArray(memberIds) || !memberIds.includes(uid)) {
        return <p>You're not a member of this hunt. <Link to={"/join/" + huntId}>Join it</Link> first.</p>
    }

    const nameMap = new Map(players.docs.map((p) => [p.id, nameOf(p)]));


    // TODO query database by item and do sorting there

    let submsTable = new Map(items.docs.map((item) => [item.ref.path, []]));
    subms.docs.forEach((s) => {
        // Since this returns a ref, we need to ask for .path
        submsTable.get(s.data().item.path).push([s.id, s.data()]);
    });

    submsTable.forEach((arr) => {
        console.log(arr)

        arr.sort(([_1, s1], [_2, s2]) => {
            return s1.takenTime.seconds - s2.takenTime.seconds;
        })
    })


    function imagesForItem(itemRef) {
        if (submsTable.get(itemRef).length === 0) {
            return <p> No submissions :( </p>
        }
        return submsTable.get(itemRef).map(([id, s]) =>
            <div key={id} style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid",

            }}>
                <SubmissionMedia submission={s} height={200} />
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                }}>
                    <b>{nameMap.get(s.player.id) ?? s.player.id}</b>
                    &nbsp;
                    ({moment(new Date(s.takenTime.seconds * 1000)).format("MMM D")})
                </div>
            </div>
        )
    }


    return <div>
        <h1>
            {hunt.data().displayName} Gallery:
        </h1>

        {
            items.docs.map((item) =>
                <div key={item.id}>
                    <h3>
                        {item.data().desc}
                    </h3>

                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        flexFlow: "row wrap",
                        gap: "10px",
                    }}>
                    {
                        imagesForItem(item.ref.path)
                    }

                    </div>
                </div>
            )

        }
    </div>

}
